import styled from '@emotion/styled';
import { dropdown } from '../../../../styles/animation/dropdown';
import { Color } from '../../../../styles/Color';
import { Z_INDEX_MAIN_NAV_ITEM } from '../../../../styles/zIndex';
import { UnstyledUl, Css, Responsive, UnstyledLi, H6 } from '../../../../ui';
import { RouterLink } from '../../link/RouterLink';
import { SubMenuNavItemCommon } from '../Navigation.styles';
import { swipe } from '../../../../styles/animation/swipe';

export const Container = styled.div<{ open: boolean }>`
	width: 100%;
	min-height: ${Css.pxToRem(224)};
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(24)};

	position: absolute;
	left: 0;
	top: ${Css.pxToRem(48)};
	padding: ${Css.pxToRem(40)} ${Css.pxToRem(40)} ${Css.pxToRem(32)};

	border-radius: ${Css.pxToRem(8)};
	background-color: ${Color.PrimaryWhite};

	${({ open }) => dropdown(open)}
	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		overflow: hidden;
		width: 100%;
		height: 100vh;
		top: 0;
		background-color: ${Color.PrimaryWhite};
		transition: all 0.4s ease-in-out;
		${({ open }) => swipe(open)}
		pointer-events: ${({ open }) => (open ? 'auto' : 'none')};
		z-index: ${Z_INDEX_MAIN_NAV_ITEM};
		padding: ${Css.pxToRem(40)} ${Css.pxToRem(24)};
	}
`;

export const ListContainer = styled(UnstyledUl)`
	height: ${Css.pxToRem(126)};

	display: flex;
	gap: ${Css.pxToRem(10)};
	flex-direction: column;
	flex-wrap: wrap;
	align-content: start;
	column-gap: ${Css.pxToRem(32)};

	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		height: 90%;
		min-height: unset;
		max-height: unset;
		display: flex;
		flex-direction: column;
		gap: ${Css.pxToRem(32)};
	}
`;

export const StyledSubmenuItemWrap = styled(UnstyledLi)`
	width: fit-content;
	min-width: ${Css.pxToRem(200)};
	position: relative;
`;

export const StyledSubmenuItem = styled(RouterLink)`
	text-decoration: none;
	line-height: ${Css.pxToRem(24)};
	letter-spacing: ${Css.pxToRem(0.5)};
	color: ${Color.Neutral};

	&:hover {
		color: ${Color.PrimaryBlue};
	}
	${SubMenuNavItemCommon}

	@media (${Responsive.getMediaQueryForBreakpoint('desktop')}) {
		font-size: ${Css.pxToRem(20)};
		color: ${Color.OnBackgroundText2};
	}
`;

export const SubMenuHeader = styled(H6)`
	height: ${Css.pxToRem(24)};
	margin: 0;
`;
